if (!customElements.get('qg-sticky-cart')) {
  customElements.define(
    'qg-sticky-cart',
    class QgStickyCart extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.nativeButton = document.getElementById(this.dataset.buttonId);
        this.price = document.getElementById(this.dataset.priceId);
        this.button = this.querySelector('[data-qg-sticky-submit]');
        this.productInfo = this.closest('product-info');
        this.button?.addEventListener('click', () => this.nativeButton?.click(), { signal: this.controller.signal });
        this.productInfo?.addEventListener(
          'qg:custom-price-change',
          (event) => {
            this.customPriceText = event.detail?.valid ? event.detail.formattedPrice : '';
            this.sync();
          },
          { signal: this.controller.signal },
        );
        this.observe();
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }

      observe() {
        if (this.nativeButton) {
          this.intersectionObserver = new IntersectionObserver(([entry]) => {
            const mobile = window.matchMedia('(max-width: 749px)').matches;
            const hasPassedNativeButton = entry.boundingClientRect.bottom <= 0;
            this.setAttribute('aria-hidden', String(!mobile || !hasPassedNativeButton));
          });
          this.intersectionObserver.observe(this.nativeButton);
        }
        if (this.price || this.nativeButton) {
          this.mutationObserver = new MutationObserver(() => this.sync());
          if (this.price) {
            this.mutationObserver.observe(this.price, { childList: true, subtree: true, characterData: true });
          }
          if (this.nativeButton) {
            this.mutationObserver.observe(this.nativeButton, {
              attributes: true,
              attributeFilter: ['disabled', 'aria-disabled'],
              childList: true,
              subtree: true,
              characterData: true,
            });
          }
        }
      }

      sync() {
        const variantPriceText = this.price
          ?.querySelector('.price-item--regular, .price-item--sale')
          ?.textContent?.trim();
        const priceText = this.customPriceText || variantPriceText;
        const priceTarget = this.querySelector('[data-qg-sticky-price]');
        if (priceTarget && priceText) priceTarget.textContent = priceText;
        if (!this.button || !this.nativeButton) return;
        this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
        const nativeText = this.nativeButton.querySelector('span')?.textContent?.trim();
        this.button.textContent = nativeText || this.button.textContent;
      }
    }
  );
}
